

export const usefulllinks=[
    {
        id:1,
        title:"Privacy Policy",
        path:"",
    },
    {
        id:2,
        title:"Cookie Policy",
        path:"",
    },
    {
        id:3,
        title:"Licensing",
        path:"",
    },
    {
        id:4,
        title:"Faqs",
        path:"/faq",
    },
 
]